import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="not-found">
      <span>404</span>
      <h1>That surface does not exist.</h1>
      <p>The route may have moved, been archived, or never existed in this workspace.</p>
      <div className="hero-actions">
        <Link className="btn primary" to="/">Sales home</Link>
        <Link className="btn secondary" to="/dashboard">Dashboard</Link>
      </div>
    </section>
  );
}
